import PaginatedList from '@theme/paginated-list';

/**
 * Blog posts list with last-page boundary check.
 * Prevents infinite scroll from pushing ?page=2 when there's only 1 page.
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    // If there's only one page, disconnect the infinity scroll observer
    // to prevent URL changes to ?page=2 on a single-page blog
    const grid = this.querySelector('[ref="grid"]');
    if (grid) {
      const lastPage = parseInt(grid.getAttribute('last-page'), 10);
      if (lastPage <= 1 && this.infinityScrollObserver) {
        this.infinityScrollObserver.disconnect();
      }
    }
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
